"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSCodeEnvironment = void 0;
const IVSCodeEnvironment_1 = require("./IVSCodeEnvironment");
const vscode = require("vscode");
class VSCodeEnvironment extends IVSCodeEnvironment_1.IVSCodeEnvironment {
    constructor() {
        super();
    }
    isTelemetryEnabled() {
        return vscode.env.isTelemetryEnabled;
    }
}
exports.VSCodeEnvironment = VSCodeEnvironment;
//# sourceMappingURL=VSCodeEnvironment.js.map